import React from 'react';
import MediaQuery from 'react-responsive'
import './Home5-2.scss'

const Home5 = ({sectionCurrently, positionCurrently, Section, Position, responsive}) => {

    return (
        <>
            <MediaQuery minWidth={951}>
                <div className = "six-body-section fade-slide-in-animation disposition-row justify-center align-center" >
                    <img src="assets/Home/Home5-2/Home5-2-background.png" className="background-img" alt="Background"></img>
                    <div className = "six-body-elements disposition-column justify-start align-center">
                        <div className="solid-overlay"></div>
                        <div className="gradient-overlay"></div>
                        <div className="row-container disposition-row justify-around align-center">
                          <div className="first-half disposition-column justify-center align-center">
                            <div className="section-header disposition-row justify-center align-center">
                              <p className = "title-1">Automatic Europe Tax Refund</p>
                            </div>
                            <div className = "cards-section disposition-row justify-center align-center">
                              <div className = "card-body justify-center align-start">
                                <div className="small-card">
                                  <p className="step-title"><b>STEP 01</b></p>
                                  <p className = "text-1">Just take a picture of the receipt while purchasing</p>
                                </div>
                                <div className="card-img">
                                  <img src = "assets/Home/Home5/card1.png" className = "card-img" alt = "Card 1"></img>
                                </div>
                              </div>
                              <div className = "card-body justify-center align-start">
                                <div className="small-card">
                                  <p className="step-title"><b>STEP 02</b></p>
                                  <p className = "text-1">Send it to the concierge via WhatsApp</p>
                                </div>
                                <div className="card-img">
                                  <img src = "assets/Home/Home5/card2.png" className = "card-img" alt = "Card 2"></img>
                                </div>
                              </div>
                              <div className = "card-body justify-center align-start">
                                <div className="small-card">
                                  <p className="step-title"><b>STEP 03</b></p>
                                  <p className = "text-1">Voila! The refund is credited to your card</p>
                                </div>
                                <div className="card-img">
                                  <img src = "assets/Home/Home5/card3.png" className = "card-img" alt = "Card 3"></img>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="second-half">
                            <img src="assets/Home/Home5-2/Home5-2-phone.png" className="phone-img" alt="Phone"></img>
                          </div>
                        </div>
                    </div>
                </div>
            </MediaQuery>
            <MediaQuery maxWidth={950.99}>
                <div className = "six-body-section-t fade-slide-in-animation disposition-row justify-center align-center" >
                    <div className = "six-body-elements disposition-column justify-start align-center">
                        <img src="assets/Home/Home5-2/Home5-2-background.png" className="background-img" alt="Background"></img>
                        <div className="solid-overlay"></div>
                        <div className="gradient-overlay"></div>
                        <div className="card-solid-background disposition-column align-center">
                          <p className = "title-1 align-center">Automatic Europe Tax Refund</p>
                          <div className = "cards-section disposition-row justify-between align-center">
                            <div className = "card-body justify-center align-start">
                              <div className="card-start-divider"></div>
                              <div className="small-card">
                                <p className="step-title"><b>STEP 01</b></p>
                                <p className = "text-1">Just take a picture of the receipt while purchasing</p>
                              </div>
                              <div className="card-img">
                                <img src = "assets/Home/Home5/card1.png" className = "card-img" alt = "Card 1"></img>
                              </div>
                            </div>
                            <div className = "card-body justify-center align-start">
                              <div className="card-start-divider"></div>
                              <div className="small-card">
                                <p className="step-title"><b>STEP 02</b></p>
                                <p className = "text-1">Send it to the concierge via WhatsApp</p>
                              </div>
                              <div className="card-img">
                                <img src = "assets/Home/Home5/card2.png" className = "card-img" alt = "Card 2"></img>
                              </div>
                            </div>
                            <div className = "card-body justify-center align-start">
                              <div className="card-start-divider"></div>
                              <div className="small-card">
                                <p className="step-title"><b>STEP 03</b></p>
                                <p className = "text-1">Voila! The refund is credited to your card</p>
                              </div>
                              <div className="card-img">
                                <img src = "assets/Home/Home5/card3.png" className = "card-img" alt = "Card 3"></img>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </MediaQuery>
        </>
    );
};

export default Home5;
